import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import React, { useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { axiosOpen } from "../../api/axios";

const CheckoutForm = (planDetails) => {
  let subscriber = {};
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [paymentStatus, setPaymentStatus] = React.useState("");
  const stripe = useStripe();
  const elements = useElements();
  let requestBody = {};

  const handleSubmit = async (event) => {
    setIsProcessingPayment(true);
    event.preventDefault();
    console.log(event.target.name.value);
    await stripe.createToken(elements.getElement(CardElement)).then((res) => {
      if (res.error) {
        console.log(res.error.message);
      } else {
        requestBody = {
          planId: planDetails.planDetails.planId,
          name: event.target.name.value,
          email: event.target.email.value,
          token: res.token.id,
        };
      }
    });
    try {
      subscriber = await axiosOpen.post("api/subscriber/create", {
        ...requestBody,
      });
      setPaymentStatus(true);
      setIsProcessingPayment(false);
      console.log(subscriber);
    } catch (err) {
      setPaymentStatus(false);
      setIsProcessingPayment(false);
      console.log(err);
    }
  };
  return (
    <Form onSubmit={handleSubmit} className="add-user-form add-plans">
      <Form.Group className="mb-3" controlId="formBasicName">
        <Form.Label>Name</Form.Label>
        <Form.Control type="text" name="name" placeholder="Name" required />
      </Form.Group>
      <Form.Group className="mb-3" controlId="formBasicAmount">
        <Form.Label>Email</Form.Label>
        <Form.Control type="email" name="email" placeholder="Email" required />
      </Form.Group>
      <Form.Group className="mb-3 stripe-card" controlId="formBasicAmount">
        <CardElement />
      </Form.Group>
      <div className="text-center mt-4">
        <Button variant="primary" type="submit" className="btn custom-btn" disabled={isProcessingPayment} >
        {isProcessingPayment ? (
          <>
            <Spinner animation="border" size="sm" role="status" />
            <span className="sr-only">Processing...</span>
          </>
        ) : (
          'Submit'
        )}
        </Button>
        
        { paymentStatus ? <h6 className="text-success mt-3" > Congratulations, your payment was successful! </h6> : <></>}
        { paymentStatus === false ? <h6 className="text-danger mt-3" > Sorry, your payment was unsuccessful! </h6> : <></>}
      </div>
    </Form>
  );
};

export default CheckoutForm;
